import Overlay from "../ux/Overlay";
import { FiMail, FiPhone } from "react-icons/fi";

const Footer = () => {
  return (
    <Overlay
      classes={
        "bg-gray-600 opacity-80 py-[2rem] flex flex-col notebook:flex-row  justify-between items-start"
      }
    >
      <div id="about-us" className="mb-[1rem] notebook:w-[33%]">
        <p className="text-white font-bold text-[1.75rem] desktop:text-[2rem] full:text-[3rem] mb-[.5rem]">
          about us
        </p>
        <p className="text-white font-light text-[.9rem] desktop:text-[1rem] full:text-[1.2rem]">
          We offer help starting your business in the USA since early 2023,
      always centered on giving tailored services to our clients.
        </p>
      </div>

      <div className="text-white">
        <p className=" font-bold text-[1.75rem] desktop:text-[2rem] full:text-[3rem] mb-[.5rem] ">contact</p>
        <div className="flex flex-row items-center font-light desktop:text-[1.2rem]  mb-[.5rem]">
          <FiMail className="mr-[1rem]" />
          martin@rcmds.info
        </div>

        <div className="flex flex-row font-light items-center desktop:text-[1.2rem]">
          <FiPhone className="mr-[1rem]" />
          +1 (561) 437-2076
        </div>
        <p className="text-[.7rem] desktop:text-[.9rem] mt-[2rem]">
          {" "}
          RCMDS LLC © 2025. All Rights Reserved.
        </p>
      </div>
    </Overlay>
  );
};

export default Footer;
